import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_GST, LINE_ITEM_HST, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the GST or HST line item (only one is ever present per transaction).
 * Also shows the operator's GST/HST registration number alongside it, since CRA requires this
 * on receipts for supplies of $30 or more (config.taxRegistration.gstHstNumber).
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemGstHstMaybe = props => {
  const { lineItems, intl } = props;
  const config = useConfiguration();
  const gstHstNumber = config.taxRegistration?.gstHstNumber;

  const gstOrHstLineItem = lineItems.find(
    item => (item.code === LINE_ITEM_GST || item.code === LINE_ITEM_HST) && !item.reversal
  );

  return gstOrHstLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.gstHst" />
        {gstHstNumber ? (
          <span className={css.gstHstNumber}>
            <FormattedMessage id="OrderBreakdown.gstHstNumber" values={{ gstHstNumber }} />
          </span>
        ) : null}
      </span>
      <span className={css.itemValue}>{formatMoney(intl, gstOrHstLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemGstHstMaybe;
